import { render, staticRenderFns } from "./DonutChart02.vue?vue&type=template&id=b2e06e5e&scoped=true&"
import script from "./DonutChart02.vue?vue&type=script&lang=js&"
export * from "./DonutChart02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e06e5e",
  null
  
)

export default component.exports